import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../Footer';
import { useAktualitasokEnabled } from '../../hooks/useAktualitasokEnabled';
import './styles/InfoPage.css';

const InfoPage = () => {
  const { enabled: aktualitasokEnabled } = useAktualitasokEnabled();

  return (
    <div className="info-page">
      {/* Main Content */}
      <section className="info-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Információk</h2>
            <p className="section-subtitle">
              Fontos információk a Napvirág Idősek Otthonáról
            </p>
          </div>

          {/* Main Information */}
          <div className="main-info-section">
            <div className="info-card">
              <h4>Tisztelt Látogató!</h4>
              <div className="info-content">
                <p><strong>A látogatás rendje a Házirendben foglaltak szerint:</strong></p>
                <ul>
                  <li>az általános gondozási szinteken minden nap <strong>09:00-21:00 óra között</strong></li>
                  <li>a fokozott gondozást biztosító részlegeken minden nap <strong>13:00-19:00 óra között</strong></li>
                </ul>
                <p>A fokozott gondozást biztosító részlegeken érkezésüket és távozásukat kérem jelezzék a szolgálatban lévő nővérnek!</p>
                <p>Látogatási időn kívül látogató az intézményben az intézményvezető vagy a főnővér előzetes engedélyével tartózkodhat!</p>
                
                <div className="contact-info">
                  <h5>📞 Információ szeretteikről:</h5>
                  <div className="contact-departments">
                    <div className="department">
                      <strong>Általános gondozási részleg:</strong><br/>
                      📱 +36 20 390 4496 vagy 📞 +36 26 541 017
                    </div>
                    <div className="department">
                      <strong>0. fokozott gondozási részleg:</strong><br/>
                      📱 +36 20 341 0371 vagy 📞 +36 26 541 018
                    </div>
                    <div className="department">
                      <strong>1. fokozott gondozási részleg:</strong><br/>
                      📱 +36 20 390 4596 vagy 📞 +36 26 541 019
                    </div>
                  </div>
                  <div className="signature">
                    <p><em>Lipterné Bierbaum Erika<br/>intézményvezető</em></p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links Section */}
          <div className="quick-links-section">
            <h3>ℹ️ További Információk</h3>
            <div className="links-grid">
              {aktualitasokEnabled && (
              <Link to="/informaciok/bejelentesek" className="info-link-card">
                <div className="link-icon">📢</div>
                <div className="link-content">
                  <h4>Aktualitások</h4>
                  <p>Aktuális hírek és bejelentések</p>
                </div>
              </Link>
              )}

              <Link to="/informaciok/bekoltozes" className="info-link-card">
                <div className="link-icon">🏡</div>
                <div className="link-content">
                  <h4>A beköltözésről</h4>
                  <p>Feltételek és információk</p>
                </div>
              </Link>
              
              <Link to="/informaciok/apartmanok" className="info-link-card">
                <div className="link-icon">🏠</div>
                <div className="link-content">
                  <h4>Apartmanjaink</h4>
                  <p>Lakóegységek és felszereltség</p>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default InfoPage;
